<div class="services">
    <div class="services__container">
        <section class="services__container-section">
            <app-hero-section [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath" [description]="description"
                [joinChat]="joinChat">
            </app-hero-section>
            <div class="services__section-one-container-cards">
                <div class="services__section-one-cards">
                    <div class="services__section-one-card"
                        [ngClass]="{'services__section-one-card--active' : isActiveConsultations}"
                        (click)="cardSwap('Consultations')">
                        <div class="services__section-one-svg">
                            <!-- <svg width="148" height="148" viewBox="0 0 148 148" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M129.192 41.5632C129.192 20.7816 124.012 15.6016 103.23 15.6016H38.2949C17.5133 15.6016 12.3333 20.7816 12.3333 41.5632V78.5632C12.3333 99.3449 17.5133 104.525 38.2949 104.525H61.6666V132.398H41.5632M12.3333 79.8582H61.6666"
                                    stroke="currentColor" stroke-width="5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M135.667 78.9335V114.145C135.667 128.76 132.028 132.399 117.413 132.399H95.5216C80.9066 132.399 77.2683 128.76 77.2683 114.145V78.9335C77.2683 64.3185 80.9066 60.6802 95.5216 60.6802H117.413C132.028 60.6802 135.667 64.3185 135.667 78.9335Z"
                                    stroke="currentColor" stroke-width="5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M106.338 112.542H106.4" stroke="currentColor" stroke-width="5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg> -->
                            <svg width="148" height="151" viewBox="0 0 148 151" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M49.1 74.5H99.9M74.5 99.9V49.1M55.45 138H93.55C125.3 138 138 125.3 138 93.55V55.45C138 23.7 125.3 11 93.55 11H55.45C23.7 11 11 23.7 11 55.45V93.55C11 125.3 23.7 138 55.45 138Z" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div l10nTranslate [innerHTML]="'GRC Consulting'"></div>
                        <p l10nTranslate>We provide full assessment and implementation2</p>
                    </div>
                    <div class="services__section-one-card"
                        [ngClass]="{'services__section-one-card--active' : isActiveAwareness}"
                        (click)="cardSwap('Awareness')">
                        <div class="services__section-one-svg">
                            <svg width="148" height="148" viewBox="0 0 148 148" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M73.9999 135.667C108.058 135.667 135.667 108.058 135.667 74C135.667 39.9415 108.058 12.3333 73.9999 12.3333C39.9414 12.3333 12.3333 39.9415 12.3333 74C12.3333 108.058 39.9414 135.667 73.9999 135.667Z"
                                    stroke="currentColor" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M73.9999 91.76C68.3883 91.76 63.825 87.1967 63.825 81.585V66.3533C63.825 60.7417 68.3883 56.1783 73.9999 56.1783C79.6116 56.1783 84.1749 60.7417 84.1749 66.3533V81.585C84.1749 87.1967 79.6116 91.76 73.9999 91.76Z"
                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" />
                                <path
                                    d="M104.71 83.065C103.477 98.975 90.1567 111.432 74.0001 111.432C56.9801 111.432 43.1667 97.6184 43.1667 80.5984V67.4017C43.1667 50.3817 56.9801 36.5684 74.0001 36.5684C89.9717 36.5684 103.107 48.7167 104.648 64.2567"
                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" />
                            </svg>
                        </div>
                        <div [innerHTML]="'Managed Awareness'" l10nTranslate></div>
                        <p l10nTranslate>We help you with designing and running2</p>
                    </div>
                    <div class="services__section-one-card"
                        [ngClass]="{'services__section-one-card--active' : isActiveCompliance}"
                        (click)="cardSwap('Compliance')">
                        <div class="services__section-one-svg">
                            <svg width="148" height="148" viewBox="0 0 148 148" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M73.9999 135.667C108.058 135.667 135.667 108.058 135.667 74C135.667 39.9415 108.058 12.3333 73.9999 12.3333C39.9414 12.3333 12.3333 39.9415 12.3333 74C12.3333 108.058 39.9414 135.667 73.9999 135.667Z"
                                    stroke="currentColor" stroke-width="5" stroke-miterlimit="10" />
                                <path
                                    d="M74 36.3834L57.9667 62.2834H90.0333L74 36.3834ZM53.0333 73.3834L37 99.2834H68.45L53.0333 73.3834ZM94.9667 73.3834L79.55 99.2834H111L94.9667 73.3834Z"
                                    stroke="currentColor" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div [innerHTML]="'Certification'" l10nTranslate></div>
                        <p l10nTranslate>We help you achieve compliance certification2</p>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="products-phishing__section-master-employee">
            <app-list-with-image [items]="items" [tileList]="tileSectionTwo"
              [descriptionList]="descriptionSectionTwo" [imgListPath]="imgListPath"
              [routerListButton]="routerListButton" [buttonListText]="buttonListText">
            </app-list-with-image>
          </section>


        <section class="services__container-section">
            <div class="services__section-three-row">
                <div class="services__section-three-title-bold" [innerHTML]="'Our Expertise and Reliable Engagement Process Make the Difference'" l10nTranslate>
                </div>
            </div>
            <div class="services__section-three-cards">
                <div class="services__section-three-card">
                    <img src="../../../../assets/svg/tickcircle.svg" alt="tickcircle">
                    <h4 l10nTranslate>Accumulated Experiences</h4>
                    <div class="services__section-three-card-description" l10nTranslate>We dedicate an account manager for your project</div>
                </div>
                <div class="services__section-three-card">
                    <img src="../../../../assets/svg/tickcircle.svg" alt="tickcircle">
                    <h4 l10nTranslate>Responsiveness</h4>
                    <div class="services__section-three-card-description" l10nTranslate>We follow a regular onboarding process to deploy platforms</div>
                </div>
                <div class="services__section-three-card">
                    <img src="../../../../assets/svg/tickcircle.svg" alt="tickcircle">
                    <h4 l10nTranslate>Local Support</h4>
                    <div class="services__section-three-card-description" l10nTranslate>We assign in-house software engineer to stay with you till you achieve saucerful launch</div>
                </div>
                <div class="services__section-three-card">
                    <img src="../../../../assets/svg/tickcircle.svg" alt="tickcircle">
                    <h4 l10nTranslate>Continuous Development Ideas</h4>
                    <div class="services__section-three-card-description" l10nTranslate>We provide multiple support channel with a record response time in minutes</div>
                </div>
            </div>
        </section>
    </div>
</div>
